import React from "react";

export const Loader = () => (
    <div style={{
        height: "100vh", width: "100%", position: "fixed", zIndex: "1024",
        background: "#202e43",
    }} className="text-center">
        <div class="loader" />
        <span style={{ margin: "10px", color: "white" }}>Loading...</span>
    </div>
);